<template>
  <b-modal v-model="show" size="sm" centered :title="'Sie haben die Konten des Auftrags geändert'"
  >
    <b-row class="justify-content-md-center">
      <b-col>
        <p>Bis zu welchem Datum sollen die Kontoänderungen auf <b>nicht abgerechnete</b> Leistungen getätigt werden?</p>
        <datetime
            style="-webkit-print-color-adjust: exact !important;color-adjust: exact !important; margin-top: 0.5rem"
            v-model="date"
            input-class="form-control form-control-sm"
            input-style="color: black; height: auto; padding-top: 3px; padding-bottom: 3px;"
            input-id="date"
            :max-datetime="datetimeConfig.maxTime"
            :phrases="datetimeConfig.phrases"
            :format="{ day: '2-digit', month: '2-digit', year: 'numeric'}"
            size="sm"
        ></datetime>
      </b-col>
    </b-row>
    <template #modal-footer="{ok, cancel}">
      <!-- Emulate built in modal footer ok and cancel button actions -->
      <b-button size="md" variant="primary" @click="onCancel">
        Abbrechen
      </b-button>
      <b-button size="md" :disabled="!canContinue" variant="success" @click="onSave">
        Speichern
      </b-button>
    </template>
  </b-modal>
</template>

<script>
import {DateTime as LuxonDateTime} from "luxon";

export default {
  name: "CheckHhDateDialog",
  props:{
  },
  data() {
    return {
      show: false,
      date: LuxonDateTime.local().toISO(),
      datetimeConfig: {phrases: {ok: 'Ok', cancel: 'Abbruch'}, maxTime: LuxonDateTime.local().toISO()},
    }
  },
  computed: {
    canContinue() {
      return this.date !== null && this.date !== '';
    },
  },
  methods: {
    showModal() {
      this.date = LuxonDateTime.local().toISO();
      this.show = true;
    },
    getReturnData() {
      return this.date;
    },
    async onSave() {
      console.log(this.date)
      let data = this.getReturnData();
      this.$emit('hh-change-date', data);
      this.show = false;
    },

    onCancel() {
      this.show = false;
    }
  }
}
</script>

<style scoped>
.text-black {
  color: black;
}
.vld-overlay.is-full-page {
  z-index: 1600;
  position: fixed;
}
</style>
